import React, { useState, useContext, useEffect } from 'react';
import ViewsContext from 'contexts/viewsContext';
import HourlyLaborCumuChartGlance from './hourlyLaborCumuChartGlance';
import HourlyLaborCumuTableViewGlance from './hourlyLaborCumuTableViewGlance';




export default function ToggleHourlyLaborCumuGlance(props) {

    const { viewsState, setHourlyLaborCumuToggleState } = useContext(ViewsContext);
    const [chartToggleClass, setChartToggleClass] = useState('');
    const [tableViewToggleClass, setTableViewToggleClass] = useState('');

    useEffect(() => {
        if (viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState === 'chart') {
            setTableViewToggleClass('togglable-hidden');
            setChartToggleClass('');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState === 'tableView') {
            setChartToggleClass('togglable-hidden');
            setTableViewToggleClass('');
        }

    }, [viewsState]);

    const changeView = () => {
        if (viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState === 'chart') {
            setHourlyLaborCumuToggleState('tableView');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState === 'tableView') {
            setHourlyLaborCumuToggleState('chart');
        }
    };

    if (viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState === 'chart') {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlyLaborCumuChartGlance data={props.data} viewState={chartToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlyLaborCumuTableViewGlance data={props.data} viewState={tableViewToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }

}

